import * as angular from 'angular';
import {DataResponse, RequestStatus} from "./DataResponse";
import {DataRequest} from "./DataRequest";

angular.module('ng').config([
  "$httpProvider", $httpProvider => {
    $httpProvider.defaults.transformResponse.push(responseData => {
      convertDateStringsToDates(responseData);
      return responseData;
    });
  }
]);
// fixed
var regexIso8601 = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z$)/;

export function convertDateStringsToDates(input) {
  // Ignore things that aren't objects.
  if (typeof input !== "object") return input;

  for (var key in input) {
    if (!input.hasOwnProperty(key)) continue;

    var value = input[key];
    var match;
    if (typeof value === "string" && (match = value.match(regexIso8601))) {
      var parsedDate = Date.parse(match[0]);
      if (!isNaN(parsedDate)) {
        input[key] = new Date(parsedDate);
      }
    } else if (typeof value === "object") {
      // Recurse into object
      convertDateStringsToDates(value);
    }
  }
  return input;
}

export var mod = angular.module("tlDataServices", []);
mod.config([
  '$httpProvider', ($httpProvider: angular.IHttpProvider) => {
    $httpProvider.defaults.headers.post = {
      'Content-Type': 'application/json'
    };
  }
]);
export class RequestSenderService {
  constructor(private urlByService: { [serviceName: string]: (() => string)|string }, private $http: angular.IHttpService, private $q: angular.IQService, private $location: angular.ILocationService) { }
  getUrl(serviceName: string): string {
    var url = this.urlByService[serviceName];
    if (typeof url === "string") {
      return url;
    } else if (typeof url === "function") {
      return url();
    }
    return "api";
  }
  requestValue<T>(dataRequest: DataRequest<T>): angular.IPromise<DataResponse<T>> {
    var deferred = this.$q.defer<DataResponse<T>>();

    // make the http call
    this.$http({
      method: dataRequest.method,
      url: dataRequest.url,
      data: dataRequest.sendData ? dataRequest.data : null
    }).then((response) => {
      var responseData = response.data;
      if (dataRequest.returnType == "boolean")
        responseData = (responseData == "true" || responseData === true);
      else if (dataRequest.returnType == "number")
        responseData = +responseData;
      else if (dataRequest.returnType != "string" && responseData == "null")
        responseData = null;

      deferred.resolve(new DataResponse<T>(responseData as T, RequestStatus.Success, response as any));
    },(response) => {
      deferred.reject(new DataResponse<T>(response.data, RequestStatus.Failure, response));
    });

    return deferred.promise;
  }
}
export class RequestSenderProvider implements angular.IServiceProvider {
  setUrl(newUrl: (() => string)|string , proxyServiceName: string) {
    this.urlPerService[proxyServiceName] = newUrl;
  }
  $get = ['$http', '$q', '$location', ($http: angular.IHttpService, $q: angular.IQService, $location: angular.ILocationService) => {
    return new RequestSenderService(this.urlPerService, $http, $q, $location);
  }
  ];
  urlPerService: { [serviceName: string]: (() => string)|string  } = {};
}
mod.provider('$requestSender', [RequestSenderProvider]);